
export const calcGapY = (state) => {
    if (window.innerWidth<440) {
        return (204-39*3) / 4;
    }
    if (window.innerWidth>=440 && window.innerWidth<736) {
        return (248-39*3) / 4;
    }
    if (window.innerWidth>=736 &&window.innerWidth<1024) {
        return (260-39*3) / 4;
    }
    if (window.innerWidth>=1024 && window.innerWidth<1440) {
       if (state) {
          return (286-39*3) / 4;
       } else {
          return (354-49*3) / 4;
       }
    }
    if (window.innerWidth>=1440 && window.innerWidth<1920) {
        if (state) {
            return (364-50*3) / 4;
        } else {
            return (446-69*3) / 4;
        }
    }
    if (window.innerWidth>=1920) {
        if (state) {
            return (448-70*3) / 4;
        } else {
            return (538-89*3) / 4;
        }
    }
}


export const generateAnswers = (level) => {
    const max =
        level === "beginner"
            ? 5
            : level === "advanced"
                ? 20
                : 10;

    const answers = new Set();

    while (answers.size < 3) {
        answers.add(
            Number(
                (Math.random() * (max - 1) + 1).toFixed(1)
            )
        );
    }

    return Array.from(answers);
};

export const getFirstNumber = (answer) => {
    const max = answer - 0.1;
    const min = 0.1;

    return Number(
        (Math.random() * (max - min) + min).toFixed(1)
    );
};

export const getAnswers = (answer) => {
    const arr = new Set();

    while (arr.size < 3) {
        arr.add(
            Number(
                (Math.random() * 20 + 0.1).toFixed(1)
            )
        );
    }

    const newArr = Array.from(arr);

    if (!newArr.includes(answer)) {
        newArr[Math.floor(Math.random() * 3)] = answer;
    }

    return newArr.sort(() => Math.random() - 0.5);
};

export const getAnimationValues = () => {
    const values = [Math.random()*100];
    while(values.length < 5) {
        values.push(Math.random()*100+values[values.length-1]);
    }
    return values;
}

export const getCoordinates = () => {
    const elem = document.querySelector('.adding');
    const answer = document.querySelector('.answer');
    const x1 = elem.getBoundingClientRect().x;
    const y1 = elem.getBoundingClientRect().y;
    const x2 = answer.getBoundingClientRect().x;
    const y2 = answer.getBoundingClientRect().y;
    const xDistance = x1 - x2;
    const yDistance = y1 - y2;
    return [
              xDistance-(answer.getBoundingClientRect().width-elem.getBoundingClientRect().width)/2, 
              yDistance-(answer.getBoundingClientRect().height-elem.getBoundingClientRect().height)/2
           ];
}